"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LineConstraint_point1, _LineConstraint_point2, _LineConstraint_radius, _LineConstraint_rotation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineConstraint = void 0;
const gl_matrix_1 = require("gl-matrix");
/**
 * The line constraint is used for dragging and allows the specification of a line along which objects can be dragged.
 * The radius defines in which distance this constraint is being considered to be chosen from the constraints defined.
 * The transformation and optional rotation of this constraint get applied to the node if it is the constraint with the closest distance to the ray that was used for the drag event.
 * As this is a difficult topic, please visit our [help desk section on interactions](https://help.shapediver.com/doc/interactions-part-1) where we go through the process of setting everything up with examples.
 *
 * @deprecated This class is deprecated and will be removed in the future. Please use the `LineRestriction` instead.
 */
class LineConstraint {
    // #endregion Properties (4)
    // #region Constructors (1)
    /**
     * @param _point1 the start point of the line
     * @param _point2 the end point of the line
     * @param _radius the radius in which the line is considered
     * @param _rotation the rotation in [axis-angle representation](https://en.wikipedia.org/wiki/Axis%E2%80%93angle_representation) that is applied to the node if the drag contraint becomes active
     */
    constructor(_point1, _point2, _radius = 0, _rotation) {
        // #region Properties (4)
        _LineConstraint_point1.set(this, void 0);
        _LineConstraint_point2.set(this, void 0);
        _LineConstraint_radius.set(this, 0);
        _LineConstraint_rotation.set(this, void 0);
        __classPrivateFieldSet(this, _LineConstraint_point1, _point1, "f");
        __classPrivateFieldSet(this, _LineConstraint_point2, _point2, "f");
        __classPrivateFieldSet(this, _LineConstraint_radius, _radius, "f");
        __classPrivateFieldSet(this, _LineConstraint_rotation, _rotation || {
            axis: gl_matrix_1.vec3.fromValues(0, 0, 1),
            angle: 0,
        }, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get point1() {
        return __classPrivateFieldGet(this, _LineConstraint_point1, "f");
    }
    get point2() {
        return __classPrivateFieldGet(this, _LineConstraint_point2, "f");
    }
    get radius() {
        return __classPrivateFieldGet(this, _LineConstraint_radius, "f");
    }
    get rotation() {
        return __classPrivateFieldGet(this, _LineConstraint_rotation, "f");
    }
}
exports.LineConstraint = LineConstraint;
_LineConstraint_point1 = new WeakMap(), _LineConstraint_point2 = new WeakMap(), _LineConstraint_radius = new WeakMap(), _LineConstraint_rotation = new WeakMap();
//# sourceMappingURL=LineConstraint.js.map